<template>
  <div class="goods_list_container">
    <!-- 分类路径 -->
    <div class="level_nav_main">
      <div class="level_item" v-if="catePathName.path.length">
        <!-- 一级分类，显示该部分 -->
        <template v-if="1 === showIndex">
          <div class="level_nav_item">
            <a class="level_link">{{ catePathName.path[0] }}</a>
          </div>
          <!-- <i class="level-right"></i> -->
          <div class="level_nav_item">
            <div class="menu_drop">
              <div :class="{ trigger: true, hasChild: cate1.cate.length }">
                <span class="trigger_name">全部分类</span>
                <i class="menu_drop_arrow"></i>
              </div>
              <div class="menu_drop_main" v-if="cate1.cate.length">
                <ul class="menu_drop_list">
                  <li
                    v-for="({ categoryName, categoryId }, index) in cate1.cate"
                    :key="index"
                  >
                    <router-link :to="`/goods/list?categoryId=${categoryId}`">{{
                      categoryName
                    }}</router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </template>

        <!-- 进入二级分类路径下的页面时，显示该部分 -->
        <template v-else-if="2 === showIndex">
          <div class="level_nav_item">
            <div class="menu_drop">
              <div :class="{ trigger: true, hasChild: cate1.cate.length }">
                <span class="trigger_name">{{ catePathName.path[0] }}</span>
                <i class="menu_drop_arrow"></i>
              </div>
              <div class="menu_drop_main" v-if="cate1.cate.length">
                <ul class="menu_drop_list">
                  <li
                    v-for="({ categoryName, categoryId }, index) in cate1.cate"
                    :key="index"
                  >
                    <router-link :to="`/goods/list?categoryId=${categoryId}`">{{
                      categoryName
                    }}</router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <i class="level-right"></i>
          <div class="level_nav_item">
            <div class="menu_drop">
              <div :class="{ trigger: true, hasChild: cate2.cate.length }">
                <span class="trigger_name">{{ catePathName.path[1] }}</span>
                <i class="menu_drop_arrow"></i>
              </div>
              <div class="menu_drop_main" v-if="cate2.cate.length">
                <ul class="menu_drop_list">
                  <li
                    v-for="({ categoryName, categoryId }, index) in cate2.cate"
                    :key="index"
                  >
                    <a @click="goCate3(categoryId)">{{ categoryName }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </template>

        <!-- 进入三级分类路径下的页面时，显示该部分 -->
        <template v-else>
          <div style="float: left">
            <div class="level_nav_item">
              <div class="menu_drop">
                <div :class="{ trigger: true, hasChild: cate1.cate.length }">
                  <span class="trigger_name">{{ catePathName.path[0] }}</span>
                  <i class="menu_drop_arrow"></i>
                </div>
                <div class="menu_drop_main" v-if="cate1.cate.length">
                  <ul class="menu_drop_list">
                    <li
                      v-for="({ categoryName, categoryId },
                      index) in cate1.cate"
                      :key="index"
                    >
                      <router-link
                        :to="`/goods/list?categoryId=${categoryId}`"
                        >{{ categoryName }}</router-link
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <i class="level-right"></i>
            <div class="level_nav_item">
              <div class="menu_drop">
                <div :class="{ trigger: true, hasChild: cate2.cate.length }">
                  <span class="trigger_name">{{ catePathName.path[1] }}</span>
                  <i class="menu_drop_arrow"></i>
                </div>
                <div class="menu_drop_main" v-if="cate2.cate.length">
                  <ul class="menu_drop_list">
                    <li
                      v-for="({ categoryName, categoryId },
                      index) in cate2.cate"
                      :key="index"
                    >
                      <router-link
                        :to="`/goods/list?categoryId=${categoryId}`"
                        >{{ categoryName }}</router-link
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <i class="level-right"></i>
            <div class="level_nav_item">
              <div class="menu_drop">
                <div :class="{ trigger: true, hasChild: cate3.cate.length }">
                  <span class="trigger_name">{{ catePathName.path[2] }}</span>
                  <i class="menu_drop_arrow"></i>
                </div>
                <div class="menu_drop_main" v-if="cate3.cate.length">
                  <ul class="menu_drop_list">
                    <li
                      v-for="({ categoryName, categoryId },
                      index) in cate3.cate"
                      :key="index"
                    >
                      <a @click="goCate3(categoryId)">{{ categoryName }}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </template>

        <div class="level_nav_item" style="margin-left: 10px">
          <div
            class="menu_drop"
            v-for="(item, index) in attriListTemp"
            :key="index"
          >
            <div class="trigger label" @click="attriKick(index, item)">
              <span class="trigger_name">
                {{ item.name }}:&nbsp;
                <font color="#e2231a">{{ item.value }}</font>
              </span>
              <span>
                <i class="el-icon-close"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="level_item" v-show="keyword">
        <div class="level_nav_item" style="font-size: 13px">
          <a class="level_link">
            <i style="color: #e22319">"{{ keyword }}" &nbsp;</i>搜索结果
          </a>
        </div>
      </div>
    </div>
    <div class="goods_list_banner">
      <!-- 二级分类或者三级分类的组件 -->
      <GoodsListCate2
        :cateItem="cate1.child"
        :cate2Name="catePathName.path[0]"
        v-show="showIndex === 1"
      ></GoodsListCate2>
      <GoodsListCate2
        :cateItem="cate2.child"
        :cate2Name="catePathName.path[1]"
        v-show="showIndex === 2"
      ></GoodsListCate2>
      <GoodsListCate3
        :categoryid="categoryId3"
        v-show="showIndex === 3"
        @attriOption="attriOption"
        @brandOption="brandOption"
        ref="goodsCate3"
      ></GoodsListCate3>
    </div>

    <div class="goods_list clearfix">
      <!-- 筛选区域 -->
      <div class="sld_screen">
        <a @click="filterSort(0)" :class="0 === indexNum ? 'btn_sort' : ''">{{
          L['综合']
        }}</a>
        <a @click="filterSort(8)" :class="8 === indexNum ? 'btn_sort' : ''"
          >最新</a
        >
        <a @click="filterSort(1)" :class="1 === indexNum ? 'btn_sort' : ''">
          {{ L['销量'] }}
          <i class="iconfont" style="font-size: 12px"></i>
        </a>
        <a @click="filterSort(2)" :class="2 === indexNum ? 'btn_sort' : ''">
          {{ L['评论数'] }}
          <i class="iconfont" style="font-size: 12px"></i>
        </a>
        <a
          :class="{
            sld_price_jt_down: indexNum == 4,
            sld_price_jt_up: indexNum == 3
          }"
          @click="filterSort(indexNum == 4 ? 3 : 4)"
          >{{ L['价格'] }}</a
        >

        <div class="price_section on">
          <div class="input_box">
            <input
              type="number"
              min="0"
              class="sld_rmb"
              v-model="lowprice"
              id="lowprice"
            />
            <span class="line"></span>
            <input
              type="number"
              min="0"
              class="sld_rmb"
              v-model="highprice"
              id="highprice"
            />
          </div>

          <div class="ctrl clearfix">
            <a class="fl clearVal" @click="reset">{{ L['清空'] }}</a>
            <a class="fr confirm" @click="confirm">{{ L['确定'] }}</a>
          </div>
        </div>
        <div class="goods_type">
          {{ L['商品类型'] }}:
          <p>
            <input
              type="checkbox"
              :value="isOwnShop"
              id="isOwn"
              @input="filterStoreSelf(isOwnShop)"
            />
            <label for="isOwn">{{ L['仅平台自营'] }}</label>
          </p>
        </div>
        <span class="sld_goods_num"
          >{{
            goodsData.page ? goodsData.page.total : goodsData.data.length
          }}件相关商品</span
        >
      </div>

      <!-- 商品列表 -->
      <ul
        :class="{ sld_goods_list: true, skeleton_sld_goods_list: firstLoading }"
      >
        <li
          v-for="({
            goodsName,
            goodsImage,
            goodsPrice,
            activityList,
            isFollowGoods,
            defaultProductId,
            isAuthentic
          },
          index) in firstLoading ? skeletonData.data : goodsData.data"
          :key="index"
          @click="abc"
        >
          <div class="sld_img sld_img_center">
            <!-- <router-link target="_blank" :to="`/goods/detail?productId=${defaultProductId}`"> -->
            <img
              :src="goodsImage"
              alt
              @click="goDetails(isAuthentic, defaultProductId)"
            />
            <!-- </router-link> -->
          </div>
          <p class="clearfix">
            <span class="sld_goods_price fl">
              $
              <em>{{ goodsPrice }}</em>
            </span>
            <!-- <span class="fr">{{L['成交量']}} <em>{{saleNum}}</em></span> -->
          </p>
          <div class="sld_h32_hide">
            <router-link
              class="sld_goods_name"
              target="_blank"
              :to="`/goods/detail?productId=${defaultProductId}`"
            >
              <span v-html="goodsName"></span>
            </router-link>
          </div>
          <a href="#" class="sld_vendor_name"></a>
          <div class="tag">
            <p class="fl">
              <span
                class="tag_b"
                v-for="({ promotionName }, index) in activityList"
                :key="index"
                >{{ promotionName }}</span
              >
            </p>
            <button
              class="sld_follow fr followGoods0"
              v-if="!isFollowGoods"
              @click="collectGoods(defaultProductId, isFollowGoods)"
            >
              <i class="iconfont">&#xe612;</i>
              {{ L['收藏'] }}
            </button>
            <button
              class="sld_follow fr followGoods0"
              v-else
              @click="collectGoods(defaultProductId, isFollowGoods)"
            >
              <i>
                <img
                  src="../../assets/goods/collection.png"
                  alt
                  width="22"
                  height="22"
                />
              </i>
              {{ L['已收藏'] }}
            </button>
            <div class="xian"></div>
          </div>
          <!-- <div class="gecity">
            <div>{{ factoryName }}</div>
            <div>{{ areaInfo }}</div>
          </div> -->
        </li>
      </ul>
      <SldCommonEmpty v-show="isEmpty" />
    </div>

    <!-- 分页 -->
    <div class="flex_row_center_center sld_pagination">
      <el-pagination
        @prev-click="handlePrevCilickChange"
        @next-click="handleNextCilickChange"
        @current-change="handleCurrentChange"
        :page-size="goodsData.page ? goodsData.page.pageSize : 1"
        layout="prev, pager, next, jumper"
        :total="goodsData.page ? goodsData.page.total : goodsData.data.length"
      ></el-pagination>
    </div>

    <SldLoginModal
      :visibleFlag="loginModalVisibleFlag"
      @closeLoingModal="closeLoingModal"
    />
  </div>
</template>
<script>
import {
  getCurrentInstance,
  onMounted,
  reactive,
  ref,
  watchEffect,
  watch
} from 'vue'
import { ElMessage } from 'element-plus'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import GoodsListCate2 from './GoodsListCate2'
import GoodsListCate3 from './GoodsListCate3'
import SldLoginModal from '../../components/loginModal'
import SldCommonEmpty from '../../components/SldCommonEmpty'

export default {
  name: 'goodsList',
  components: {
    GoodsListCate2,
    GoodsListCate3,
    SldLoginModal,
    SldCommonEmpty
  },
  setup () {
    //变量------------------------------
    const firstLoading = ref(true) //是否第一次加载
    const skeletonData = reactive({ data: [] })
    const store = useStore()
    const loginModalVisibleFlag = ref(false) //登录弹框是否显示，默认不显示
    const initSkeletonData = () => {
      for (let i = 0; i < 10; i++) {
        skeletonData.data.push({
          goodsName: '',
          goodsImage: '',
          goodsPrice: '',
          // saleNum: '',
          activityList: '',
          isFollowGoods: '',
          defaultProductId: '',
          factoryName: '',
          areaInfo: ''
        })
      }
    }
    initSkeletonData()

    const route = useRoute()
    const router = useRouter()
    const catePath = ref([]) //导航路径
    const showIndex = ref(0) //显示flag
    const catePathName = reactive({ path: [] }) //需要在页面显示的整个分类路径
    const params = reactive({
      //初始化的请求参数
      current: 1,
      sort: 0
    })
    const { proxy } = getCurrentInstance()
    const L = proxy.$getCurLanguage()
    const goodsData = reactive({ data: [], page: {} })
    const indexNum = ref(0)
    const lowprice = ref(null)
    const highprice = ref(null)
    const isEmpty = ref(false)
    const keyword = ref(
      route.query.keyword != undefined && route.query.keyword
        ? route.query.keyword
        : ''
    ) //搜索关键词
    const cate1 = reactive({ cate: {}, child: {} })
    const cate2 = reactive({ cate: {}, child: {} })
    const cate3 = reactive({ cate: {} })
    const categoryId3 = ref(
      route.query.categoryId != undefined && route.query.categoryId
        ? route.query.categoryId
        : ''
    )
    const attriList = ref([])
    const attriListTemp = ref([])

    //方法------------------------------
    const goDetails = (judgment, defaultProductId) => {
      if (judgment) {
        let newWin = router.resolve({
          path: `/goods/detail`,
          query: { productId: defaultProductId }
        })
        // router.push({
        //   path: `/goods/detail`,
        //   query: { productId: defaultProductId },
        // });
        window.open(newWin.href, '_blank')
      } else {
        /* ElMessage('暂无权限访问，请先完成实名认证') */
        router.push('/login')
      }
    }

    //初始化数据，进行请求-start
    const getInitData = param => {
      var searchParams = {
        current: param.current,
        sort: param.sort,
        categoryIds: param.categoryIds,
        keyword: route.query.keyword,
        highPrice: param.highPrice,
        lowPrice: param.lowPrice
      }
      // if(route.query.keyword==undefined||route.query.keyword==null||route.query.keyword=='undefined'||route.query.keyword=='null'||route.query.keyword==''){

      // }else{
      //    searchParams.keyword=route.query.keyword
      // }

      proxy.$get('/v3/goods/front/goods/goodsList', searchParams).then(res => {
        // console.log(res)
        firstLoading.value = false
        if (res.state == 200) {
          console.log(res)
          goodsData.data = res.data.list
          // goodsData.data.map(item => item.goodsPrice = new Number(item.goodsPrice).toFixed(2))
          isEmpty.value = res.data.list.length ? false : true
          goodsData.page = res.data.pagination

          if (route.query.categoryId) {
            getCatePathName()
          }
        }
      })
    }
    //初始化数据，进行请求-end

    //获取分类Id数组对应的分类名--start
    const getCatePathName = () => {
      proxy.$get('/v3/goods/front/goods/category/list').then(res => {
        if (res.state == 200 && route.query.categoryId) {
          let categoryList = categorySearch(
            res.data.list,
            route.query.categoryId
          ).reverse()
          if (categoryList[0]) {
            showIndex.value = 1
            catePathName.path[0] = categoryList[0].categoryName
            cate1.cate = res.data.list
            cate1.child = categoryList[0].children
            if (categoryList[1]) {
              showIndex.value = 2
              catePathName.path[1] = categoryList[1].categoryName
              cate2.cate = cate1.child.filter(
                item => item.categoryId != categoryList[1].categoryId
              )
              cate2.child = categoryList[1].children
              if (categoryList[2]) {
                showIndex.value = 3
                catePathName.path[2] = categoryList[2].categoryName
                cate3.cate = cate2.child.filter(
                  item => item.categoryId != categoryList[2].categoryId
                )
              }
            }
          }
        }
      })
    }
    const categorySearch = (data, val) => {
      //遍历分类列表，找到该categoryId所在的id路径
      for (var i = 0; i < data.length; i++) {
        if (data[i] && data[i].categoryId == val) {
          return [
            {
              categoryId: val,
              categoryName: data[i].categoryName,
              children: data[i].children
            }
          ]
        }
        if (data[i] && data[i].children) {
          var d = categorySearch(data[i].children, val)
          if (d)
            return d.concat({
              categoryId: data[i].categoryId,
              categoryName: data[i].categoryName,
              children: data[i].children
            })
        }
      }
    }
    //获取分类Id数组对应的分类名--end

    //去往三级分类
    const goCate3 = categoryId => {
      router.push({
        path: 'list',
        query: {
          categoryId: categoryId
        }
      })
      getCatePathName()
    }

    //页数改变的方法-start
    const handlePrevCilickChange = e => {
      params.current = e
      getInitData(params)
    }
    const handleNextCilickChange = e => {
      params.current = e
      getInitData(params)
    }
    const handleCurrentChange = e => {
      console.log(e)
      params.current = e
      getInitData(params)
    }
    const filterSort = index => {
      console.log(index)
      indexNum.value = index
      params.sort = index
      params.current = 0
      getInitData(params)
    }
    //页数改变的方法-end

    //商品是否自营-start
    const isOwnShop = ref(false)
    const filterStoreSelf = e => {
      isOwnShop.value = !e
      params.isSelf = isOwnShop.value ? 1 : 0
      getInitData(params)
    }
    //商品是否自营-end

    //价格区间事件-start
    const confirm = () => {
      //价格区间确认按钮
      if (lowprice.value != null && highprice.value != null) {
        if (lowprice.value - highprice.value > 0) {
          let temp = lowprice.value
          lowprice.value = highprice.value
          highprice.value = temp
          params.highPrice = highprice.value
          params.lowPrice = lowprice.value
          params.current = 1
          getInitData(params)
        } else {
          params.highPrice = highprice.value
          params.lowPrice = lowprice.value
          params.current = 1
          getInitData(params)
        }
      }
    }
    const reset = () => {
      //价格区间清空按钮
      params.highPrice = highprice.value = null
      params.lowPrice = lowprice.value = null
      params.current = 1
      getInitData(params)
    }
    //价格区间事件-end

    //收藏及取消收藏商品
    const collectGoods = (defaultProductId, isFollowGoods) => {
      if (store.state.loginFlag) {
        //已登录
        let params = {
          productIds: defaultProductId,
          isCollect: !isFollowGoods
        }
        proxy.$post('v3/member/front/followProduct/edit', params).then(res => {
          if (res.state == 200) {
            ElMessage.success(res.msg)
            goodsData.data.map(goodsItem => {
              if (goodsItem.defaultProductId == defaultProductId) {
                goodsItem.isFollowGoods = !isFollowGoods
              }
            })
          } else {
            ElMessage.error(res.msg)
          }
        })
      } else {
        //未登录提示登录
        loginModalVisibleFlag.value = true
      }
    }
    //关闭登录弹框
    const closeLoingModal = () => {
      loginModalVisibleFlag.value = false
    }
    const abc = () => {
      if (goodsData.data[0].isReal == 0) {
        router.push({
          path: '/member/authentication'
        })
      }
    }
    //属性选择--start
    const attriOption = (attributeName, attributeValue, attributeId) => {
      //添加属性查询
      attriList.value.push(`${attributeName}_${attributeValue}`)
      attriListTemp.value.push({
        name: attributeName,
        value: attributeValue,
        type: 'attr',
        id: attributeId
      })
      params.attributeInfo = attriList.value.join(',')
      proxy.$get('/v3/goods/front/goods/goodsList', params).then(res => {
        if (res.state == 200) {
          goodsData.data = res.data.list
        }
      })
    }
    const attriKick = (index, item) => {
      //删除属性查询
      attriListTemp.value.splice(index, 1)
      if (item.type == 'attr') {
        attriList.value = attriList.value.filter(
          subitem => subitem.split('_')[0] != item.name
        )
        console.log('aaddd', attriList.value)
        proxy.$refs.goodsCate3.attrSorH(item.id)
        if (attriListTemp.value.length) {
          params.attributeInfo = attriList.value.join(',')
          proxy.$get('/v3/goods/front/goods/goodsList', params).then(res => {
            if (res.state == 200) {
              goodsData.data = res.data.list
            }
          })
        } else {
          delete params.attributeInfo
          proxy.$get('/v3/goods/front/goods/goodsList', params).then(res => {
            if (res.state == 200) {
              goodsData.data = res.data.list
            }
          })
        }
      } else if (item.type == 'brand') {
        delete params.brandIds
        proxy.$refs.goodsCate3.brandSorH()
        proxy.$get('/v3/goods/front/goods/goodsList', params).then(res => {
          if (res.state == 200) {
            goodsData.data = res.data.list
          }
        })
      }
      console.log('sssssd', attriList.value)
    }

    const brandOption = (brandId, brandName) => {
      attriListTemp.value.push({
        name: '品牌',
        value: brandName,
        type: 'brand'
      })
      params.brandIds = brandId
      proxy.$get('/v3/goods/front/goods/goodsList', params).then(res => {
        goodsData.data = res.data.list
      })
    }
    //属性选择--end

    //监听事件--start
    watchEffect(() => {
      if (route.query.keyword != undefined) {
        keyword.value = route.query.keyword
        categoryId3.value = ''
        showIndex.value = -1
        catePathName.path = []
        params.keyword = keyword.value
        delete params.categoryIds
        getInitData(params)
      } else if (route.query.categoryId != undefined) {
        categoryId3.value = route.query.categoryId
        keyword.value = ''
        params.categoryIds = route.query.categoryId
        delete params.keyword

        getInitData(params)
      }
    })
    watch(
      () => route.query.categoryId,
      (nv, ov) => {
        if (nv != ov) {
          categoryId3.value = nv
          attriList.value = []
          lowprice.value = highprice.value = null
          isOwnShop.value = false
        }
      }
    )
    watch(
      () => route.query.keyword,
      (nv, ov) => {
        if (nv != ov) {
          lowprice.value = highprice.value = null
          isOwnShop.value = false
          delete params.highPrice
          delete params.lowPrice
        }
      }
    )
    //监听事件--end

    onMounted(() => {
      if (route.query.categoryId) {
        params.categoryIds = route.query.categoryId
      } else if (route.query.keyword) {
        params.keyword = route.query.keyword
      } else if (route.query.storeId) {
        params.storeId = route.query.storeId
      }
      if (route.query.goodsIds) {
        params.goodsIds = route.query.goodsIds
      }
      if (route.query.brandId) {
        params.brandIds = route.query.brandId
      }
      getInitData(params)
    })

    //返回值
    return {
      goodsData,
      handlePrevCilickChange,
      handleNextCilickChange,
      handleCurrentChange,
      L,
      catePathName,
      catePath,
      showIndex,
      indexNum,
      filterSort,
      filterStoreSelf,
      isOwnShop,
      lowprice,
      highprice,
      confirm,
      reset,
      isEmpty,
      keyword,
      cate1,
      cate2,
      cate3,
      firstLoading,
      skeletonData,
      collectGoods,
      loginModalVisibleFlag,
      closeLoingModal,
      goCate3,
      categoryId3,
      attriOption,
      attriList,
      attriKick,
      attriListTemp,
      brandOption,
      goDetails,
      abc
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/goodsList.scss';
@import '../../style/base.scss';

input[type='checkbox'] {
  display: none;
  vertical-align: middle;
  margin-bottom: 3px;
  margin-right: 3px;
}

input[type='checkbox'] + label {
  background: url('../../assets/goods/unsel.png') left center no-repeat;
  padding-left: 20px;
  background-size: 12px 12px;
}

input[type='checkbox']:checked + label {
  background-image: url('../../assets/goods/select.png');
}

.empty_page {
  flex-direction: column;
  padding: 100px;
}

.sld_pagination {
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>
